








































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import DialogCloseNavigation from "@/components/navigations/DialogCloseNavigation.vue";

@Component({
  components: {
    DialogCloseNavigation
  }
})
export default class ScreenShotImageContents extends Vue {

  /* Property */
  @Prop() imageSource: string;
  @Prop() isShown: boolean;

  /* Computed Property */
  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      this.onCloseDialog();
    }
  }

  /* Emit Events */
  @Emit('close')
  onCloseDialog (): void {}

  /* Methods */
  private onClickDownload (ev: MouseEvent): void {
    console.log('Click ScreenShot Download');
  }

}
